"use client";
import React from "react";

export type Zone =
  | "dashboard"
  | "venta"
  | "caja"
  | "reportes"
  | "almacen"
  | "productos"
  | "proveedores"
  | "config";

export type AppContextState = {
  zone: Zone;
  setZone: (z: Zone) => void;
  lastRoute: string | null;
  setLastRoute: (r: string | null) => void;
};

const AppContext = React.createContext<AppContextState | null>(null);

export function useAppContext() {
  const ctx = React.useContext(AppContext);
  if (!ctx) throw new Error("useAppContext must be used within AppProvider");
  return ctx;
}

export default AppContext;
